import React, {useEffect, useState} from 'react';
import {GET_COLLECTION_DATA, SEARCH_COLLECTION_URL} from '../../api';
import 'datatables.net';
import 'datatables.net-responsive';
import $ from "jquery";
import cogoToast from "cogo-toast";
import {academic, academicCopyCourse} from "../../request";
import {capitalize} from "../../utils/capitalize";
import moment from "moment/moment";
import {useSelector} from "react-redux";
import generateId from "../../utils/generateChar";
import AWS from "aws-sdk";
import {encodeQueryParameter} from "../../utils/url";

const bucket = new AWS.S3({
    accessKeyId: process.env.REACT_APP_ACCESS_ID,
    secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
    signatureVersion: 'v4'
});

const Academic = () => {

    document.title = "Academic";

    const category = useSelector((state) => state.app.category);

    const token = localStorage.getItem('jwtToken');
    const auth = useSelector((state) => state.auth.user);
    const [academicId, setAcademicId] = useState(null);
    const [cover_image, set_cover_image] = useState(null);
    const [formLoading, setFormLoading] = useState(false);
    const [editForm, setEditForm] = useState(false);
    const [uploadPercentage, setUploadPercentage] = useState("Please Wait");

    useEffect(() => {
        let td_academic = $('#academic-table').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Please Wait</p>'
            },
            "searching": true,
            "lengthMenu": [[10], [10]],
            ordering: false,
            searchDelay: 650,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_DATA(auth.user.level), {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "academics",
                        fieldname: "name",
                        pageSize: data.start,
                        filter: {
                            academia: auth.user.level === 0 ? auth.user.sub : auth.user.academia._id
                        },
                        format: 'json',
                        populate: "cover category grade",
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success : function(res) {
                        let array = [];
                        res.data.map((data) => {array.push({raw: data})});
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return data.name;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.category?.name || "Not Set";
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data.grade?.name || "Not Set";
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return moment(data.createdAt).format("Do MMM, YYYY");;
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return `<nav class="nav nav-icon-only" id="fake">
                                    <a href="#/view-academic/${encodeQueryParameter(data)}" class="nav-link"><i class="fa fa-eye"></i> View</a><a href="#" class="nav-link edit_academic"><i class="fa fa-pencil-alt"></i> Edit</a><a href="#" class="nav-link delete_academic"><i class="fa fa-trash-alt"></i> Delete</a>
                                </nav>`
                    },
                    "targets": 4
                }
            ]
        });

        td_academic.on('click', '.delete_academic', function(e) {
            e.preventDefault();
            let extract_td = td_academic.row($(this).closest('tr')).data();
            $(".data-message").text(`Are you sure, you want to delete, ${capitalize(extract_td.raw.firstName)}?`);
            $('#delete-data').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                academic("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        $('#academic-table').DataTable().ajax.reload(null, false);
                        cogoToast.success("Academic successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        td_academic.on('click', '.edit_academic', function(e) {
            e.preventDefault();
            let extract_td = td_academic.row($(this).closest('tr')).data();

            setAcademicId(extract_td.raw._id);

            let grade = $("#academic-grade-select2");

            $('#name').val(extract_td.raw.name);
            $('#category').val(extract_td.raw.category._id);
            $('#description').val(extract_td.raw.description);

            $('#button-action').text("Edit Academic");
            $('#title').text("Edit Academic");

            $("#cover_image").prop("required", false);
            grade.prop("required", false).prop("disabled", true);

            let $option = [];

            $option.push($("<option selected></option>").val(extract_td.raw.grade._id).text(extract_td.raw.grade.name))

            grade.append($option).trigger('change');

            setEditForm(true);

            $("#academic_form").parsley();
            initialSelect2();
            $("#modalAcademic").modal({backdrop: 'static', keyboard: false}, "show");
        });

    }, []);

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    const onCloseModal = (id, form) => {
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        $(`#${form}`).parsley().reset();
        $(".modal-backdrop").remove();
    };

    const handleModalCourse = () => {
        setEditForm(false);
        _initializeSearch();
        $('#course_form').parsley();
        $("#modalCourse").modal({ backdrop: 'static', focus: false, show: true });
    }

    const _initializeSearch = () => {
        let modalCourse = $('#modalCourse');
        $('#course-select2').select2({
            placeholder: 'Select course or type name',
            allowClear: true,
            dropdownParent: modalCourse,
            ajax: {
                url: SEARCH_COLLECTION_URL,
                dataType: 'json',
                type: "POST",
                headers: {
                    "Authorization" : token,
                },
                data: function (query) {
                    return {
                        query: query,
                        collection: "course"
                    };
                },
                processResults: function (data) {
                    return {
                        results: $.map(data, function (item) {
                            return {
                                text: capitalize(item.name),
                                id: item._id
                            }
                        })
                    };
                }
            }
        }).on('select2:select', function(e){
            $(".select2-search__field").css({display: "none"});
        }).on('select2:unselect', function(e) {
            $(".select2-search__field").css({display: "inline-block"});
        });;

        $('#single-grade-select2').select2({
            placeholder: 'Select grade or type name',
            allowClear: true,
            width:"100%",
            dropdownParent: modalCourse,
            maximumSelectionLength: 1,
            ajax: {
                url: SEARCH_COLLECTION_URL,
                dataType: 'json',
                type: "POST",
                headers: {
                    "Authorization" : token,
                },
                data: function (query) {
                    return {
                        query: query,
                        collection: "grade"
                    };
                },
                processResults: function (data) {
                    return {
                        results: $.map(data, function (item) {
                            return {
                                text: capitalize(item.name),
                                id: item._id
                            }
                        })
                    };
                }
            }
        }).on('select2:select', function(e){
            $(".select2-search__field").css({display: "none"});
        }).on('select2:unselect', function(e) {
            $(".select2-search__field").css({display: "inline-block"});
        });;
    }

    const handleSubmit = async(e) => {
        e.preventDefault();
        setFormLoading(true);

        let name = $('#name').val();
        let description = $('#description').val();
        let category = $('#category').val();
        let grade = $("#academic-grade-select2").val()[0];

        let file = $('#cover_image').prop('files')[0];

        if(editForm) {
            let raw = {
                id: academicId,
                name,
                description,
                category,
                grade
            }

            academic("patch", raw).then((result) => {
                setFormLoading(false);

                if(!result.error) {
                    cogoToast.success("Data successfully updated.", {position: "top-right", hideAfter: 5});
                    resetForm("modalAcademic", "academic_form");
                    reloadTable();
                }
            });

            return false;
        }

        let upload = await S3upload(cover_image);

        let raw = {
            name,
            description,
            category,
            grade,
            cover: {
                name: file.name,
                type: file.type,
                size: file.size.toString(),
                location: upload.Location
            }
        }

        academic("post", raw).then((result) => {
            setFormLoading(false);

            if(!result.error) {
                cogoToast.success("Data successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalCourse", "course_form");
                reloadTable();
            }
        });
    }

    const S3upload = (file) => {
        const params = {
            Bucket: "s3.zstudy",
            Key: `uploads/${generateId(50)}`,
            Body: file,
            ContentType: file.type
        };

        return bucket.upload(params, function (err, data) {
            if (err) return console.log({ err });
            return data;
        }).promise();
    }

    const handleSubmitCourse = (e) => {
        e.preventDefault();
        setFormLoading(true);

        let courses = $("#course-select2").val();
        let grade = $("#single-grade-select2").val()[0];

        let raw = {
            courses,
            grade,
            academia: auth.user.sub
        }

        academicCopyCourse("post", raw).then((result) => {
            setFormLoading(false);

            if(!result.error) {
                cogoToast.success("Data successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalAcademic", "academic_form");
                $('#academic-table').DataTable().ajax.reload(null, false);
            }
        });
    }

    const handleFileUpload = (event) => {
        if(event.target.files[0] !== undefined && $('#cover_image').parsley().isValid() !== false) {
            let file = event.target.files[0];
            let image = new Image();
            image.src = window.URL.createObjectURL(file);
            image.onload = function() {
                set_cover_image(file);
            };
        }
    };

    const handleShowModal = () => {
        setEditForm(false);
        $('#title').text("New Course");
        $('#button-action').text("Add Course");
        $("#cover_image").prop("required", true);
        $("#academic-grade-select2").prop("required", true).prop("disabled", false);
        $("#academic_form").parsley();
        initialSelect2();
        $("#modalAcademic").modal({backdrop: 'static', keyboard: false}, "show");
    };

    const initialSelect2 = () => {
        let modalAcademic = $('#modalAcademic');
        $('#academic-grade-select2').select2({
            placeholder: 'Select grade or type name',
            allowClear: true,
            width: "100%",
            dropdownParent: modalAcademic,
            maximumSelectionLength: 1,
            ajax: {
                url: SEARCH_COLLECTION_URL,
                dataType: 'json',
                type: "POST",
                headers: {
                    "Authorization" : token,
                },
                data: function (query) {
                    return {
                        query: query,
                        collection: "grade"
                    };
                },
                processResults: function (data) {
                    return {
                        results: $.map(data, function (item) {
                            return {
                                text: capitalize(item.name),
                                id: item._id
                            }
                        })
                    };
                }
            }
        }).on('select2:select', function(e){
            $(".select2-search__field").css({display: "none"});
        }).on('select2:unselect', function(e) {
            $(".select2-search__field").css({display: "inline-block"});
        });
    }

    const reloadTable = () => {
        $('#academic-table').DataTable().ajax.reload(null, false);
    };

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Academic</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Academic</h4>
                    </div>
                    <div className="d-none d-md-block">
                        <button className="btn btn-sm pd-x-15 btn-success btn-uppercase mg-l-5 outline-none" onClick={handleShowModal.bind()}><i className="wd-10 mg-r-5 fa fa-plus"></i> New Course</button>
                        <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5 outline-none" onClick={handleModalCourse.bind()}><i className="wd-10 mg-r-5 fa fa-copy"></i> Copy Course</button>
                    </div>
                </div>

                <div className="row row-sm">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Academic</h6>
                                <div className="d-flex tx-18">
                                    <a href="javascript:void(0)" className="link-03 lh-0 mg-l-10" onClick={() => $('#academic-table').DataTable().ajax.reload()}><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="academic-table" className="table table-hover" style={{width: "100%"}}>
                                    <thead>
                                    <tr>
                                        <th className="wd-20p">Name</th>
                                        <th className="wd-20p">Category</th>
                                        <th className="wd-20p">Grade</th>
                                        <th className="wd-20p">Date</th>
                                        <th className="wd-20p">Actions</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modalCourse" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered wd-sm-650" role="document">
                    <div className="modal-content">
                        <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                            <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </a>
                            <div className="media-body">
                                <a href="" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={onCloseModal.bind(null, "modalCourse", "course_form")} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </a>
                                <h4 className="tx-18 tx-sm-20 mg-b-2" id="edit_title">Academic</h4>
                                <p className="tx-13 tx-color-02 mg-b-0" id="edit_subtitle">Fill all the required field</p>
                            </div>
                        </div>
                        <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                            <form id="course_form" className="parsley-style-1" onSubmit={handleSubmitCourse.bind()}>
                                <div id="courseWrapper" className="form-group parsley-input">
                                    <div className="d-flex justify-content-between">
                                        <label>Courses<span className="tx-danger">*</span></label>
                                    </div>
                                    <select className="form-control" id="course-select2" data-width="100%" multiple="multiple"
                                            data-parsley-class-handler="#courseWrapper"
                                            data-parsley-errors-container="#courseWrapper"
                                            autoComplete="off"
                                            required>
                                    </select>
                                </div>

                                <div id="gradeWrapper" className="form-group parsley-input">
                                    <div className="d-flex justify-content-between">
                                        <label>Grade<span className="tx-danger">*</span></label>
                                    </div>
                                    <select className="form-control" id="single-grade-select2" data-width="100%" multiple="multiple"
                                            data-parsley-class-handler="#gradeWrapper"
                                            data-parsley-errors-container="#gradeWrapper"
                                            autoComplete="off"
                                            required>
                                    </select>
                                </div>
                                {formLoading ? <button disabled className="btn btn-brand-02 btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> : <button className="btn btn-brand-02 btn-block mt-2"><i className="ion-md-add"/> Finish</button>}
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modalAcademic" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered wd-sm-650" role="document">
                    <div className="modal-content">
                        <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                            <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </a>
                            <div className="media-body">
                                <a href="" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={onCloseModal.bind(null, "modalAcademic", "academic_form")} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </a>
                                <h4 className="tx-18 tx-sm-20 mg-b-2" id="title">New Course</h4>
                                <p className="tx-13 tx-color-02 mg-b-0" id="edit_subtitle">Fill all the required field</p>
                            </div>
                        </div>
                        <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                            <form id="academic_form" className="parsley-style-1" onSubmit={handleSubmit.bind()}>
                                <div id="listenWrapper" className="form-group parsley-input">
                                    <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Category<span className="tx-danger">*</span></label>
                                    <select className="custom-select" id="category" required>
                                        <option value="" disabled selected>Select</option>
                                        {category.map((result) => <option key={result.key} value={result.key}>{result.title}</option>)}
                                    </select>
                                </div>

                                <div id="nameWrapper" className="form-group parsley-input">
                                    <label>Title<span className="tx-danger">*</span></label>
                                    <input id="name" type="text" className="form-control"
                                           placeholder="Enter name"
                                           autoComplete="off"
                                           data-parsley-class-handler="#nameWrapper" required/>
                                </div>

                                <div className="form-group">
                                    <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Cover Image</label>
                                    <input id="cover_image" type="file" className="form-control"
                                           onChange={handleFileUpload.bind()}
                                           data-parsley-filemaxmegabytes="1"
                                           data-parsley-trigger="change"
                                           data-parsley-filemimetypes="image/jpeg, image/jpg"
                                           data-parsley-max-file-size="2048576"
                                           accept="image/jpeg, image/jpg"
                                           required
                                    />
                                </div>

                                <div id="_gradeWrapper" className="form-group parsley-input">
                                    <div className="d-flex justify-content-between">
                                        <label>Grade<span className="tx-danger">*</span></label>
                                    </div>
                                    <select className="form-control" id="academic-grade-select2" data-width="100%" multiple="multiple"
                                            data-parsley-class-handler="#_gradeWrapper"
                                            data-parsley-errors-container="#_gradeWrapper"
                                            autoComplete="off"
                                            required>
                                    </select>
                                </div>

                                <div id="descriptionWrapper" className="form-group parsley-input">
                                    <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Description</label>
                                    <textarea id="description" rows="5" className="form-control"
                                              placeholder="Provide a description"
                                              data-parsley-class-handler="#descriptionWrapper" required/>
                                </div>

                                {formLoading ? <button disabled className="btn btn-brand-02 btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>{uploadPercentage}</button> : <button className="btn btn-brand-02 btn-block mt-2"><i className="ion-md-add"/> <span id="button-action">Add Video</span></button>}
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                    <div className="modal-content tx-14">
                        <div className="modal-header">
                            <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p className="mg-b-0 data-message">Empty</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                            <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Academic;
